import { createAction, props } from '@ngrx/store';

enum ErrorHandlerActionTypes {
  handleError = '[flight-shop book widget] Handle Error'
}

export const HandleError = createAction(
  ErrorHandlerActionTypes.handleError,
  props<{
    errorCode: string;
    error: string;
  }>()
);
